<template>
  <div class="mr-2">
    <form autocomplete="new-password">
      <div class="vx-col ">
        <vs-input label="Name" class="w-full" name="name" v-model="device.name"
          @input="(event) => { validationTextLength(event, 'name') }" />
      </div>
      <div class="vx-col">
        <vs-input label="Description" class="w-full mt-2mt-2" name="description" v-model="device.description"
          @input="(event) => { validationTextLength(event, 'description') }" />
      </div>
      <div class="reader-item-device-info vx-col">
        <div class="w-1/2 mr-6">
          <div class="vx-col ">
            <vs-input label="Device Model" class="w-full mt-2" disabled name="device_model" v-model="propsData.board" />
          </div>
          <div class="vx-col mt-2">
            <vs-input :label="`Physical Address (value 0-${selectedItem.max_address})`" class="w-full" name="address"
              v-model="device.address" type="text" @input="validateInput" />
          </div>
          <div class="vx-col mt-2">
            <label for class="vs-input--label">OSDP Protocol Version</label>
            <v-select v-model="device.protocol" :options="OSDP_types" :reduce="option => option.id"
              class="select_padding" :disabled="propsData.board === 'GENERIC'" name="protocol"
              placeholder="OSDP Protocol Version" />
          </div>
        </div>
        <div class="w-1/2">
          <div class="flex-item title ">
            <span>Device Resources</span>
            <span>Quantity</span>
          </div>
          <div class="flex-item info">
            <div>
              <span>Reader</span>
              <span>Input</span>
              <span>Outputs</span>
            </div>
            <div>
              <span>{{ selectedItem.readers }}</span>
              <span>{{ selectedItem.inputs }}</span>
              <span>{{ selectedItem.outputs }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-col w-full mt-3 reader-item-settings"
        v-if="propsData.board !== 'GENERIC' &&( device.protocol && device.protocol === 'OSDP_V2') ">
        <div for class="vx-col w-full label">Initializing a Secure Connection</div>
        <div class="vx-col check-box-item">
          <vs-checkbox v-model="device.secure_mode" :disabled="!device.protocol || device.protocol === 'OSDP_V1'"
            @click="() => updateRelayMode('secure_mode')">Secure Mode
            (OSDP v.2
            only) </vs-checkbox>
        </div>
        <div class="secure-container reader-item-device-info ">
          <div class="vx-col w-1/2 mr-6">
            <div class="vx-col check-box-item">
              <vs-input type="password" label="OSDP Key"
                :disabled="device.protocol === 'OSDP_V1' || !device.secure_mode" class="w-full" name="osdp_key"
                v-model="device.osdp_key" v-validate="'min:8|regex:^[a-zA-Z0-9]+$'" @input="validateOSDPKeyPassword" />
            </div>
            <div class="vx-col mt-3">
              <vs-input label="Date of installation of encryptions keys" disabled class="w-full "
                name="osdp_key_update_date"
                :value="device.osdp_key_update_date ? this.$moment(device.osdp_key_update_date).format('YYYY-MM-DD HH:mm') : ''" />
            </div>
          </div>
          <div class="w-1/2">
            <div class="flex-item title ">
              <span>Information</span>
            </div>
            <div class="flex-item info secure-connection">
              <span>
                To use "Secure mode", you must enable Installation mode' in the settings of the added
                device and click
                "Set key"
              </span>
            </div>
          </div>

        </div>
      </div>

      <div class="vx-col w-full mt-3 reader-item-settings" v-if="propsData.board !== 'GENERIC'">
        <div for class="vx-col w-full label">Settings of {{ !isREX ? "Inputs" : "Relay Outputs" }}</div>
        <div class=" flex-item mt-3">
          <div class="vx-col w-1/2 mr-6">
            <div class="vx-col check-box-item" v-if="!isREX">
              <vs-checkbox v-model="device.resource_apply" @click="() => updateRelayMode('resource_apply')">
                Apply common parameters for all Relay Inputs</vs-checkbox>
            </div>
            <div class="vx-col check-box-item" v-else>
              <vs-checkbox v-model="device.resource_apply" @click="() => updateRelayMode('resource_apply')">
                Apply common parameters for all relay Outputs</vs-checkbox>
            </div>
            <div class="vx-col" v-if="!isREX">
              <label for class="vs-input--label">Condition</label>
              <v-select v-model="device.condition" :options="condition_list" :reduce="option => option.id"
                class="select_padding" name="condition" placeholder="condition" />
            </div>
            <div class="vx-col mt-8" v-else>
              <label for class="vs-input--label">Relay mode</label>
              <v-select v-model="device.relay_mode" :reduce="option => option.id" :options="relayModeList"
                class="select_padding  relay-mode" name="relay_mode" placeholder="Relay Mode" />
            </div>
          </div>
          <div class="vx-col w-1/2" v-if="isREX">
            <div class="vx-col ">
              <vs-input label="Impulse Time, s" :disabled="(device.relay_mode == 0)" class="w-full " name="impulse_time"
                v-model="device.impulse_time" @input="impulseDurationValidation" />
            </div>
            <div class="vx-col mt-2 ">
              <vs-input label="Open Durations, s" class="w-full" name="open_duration" v-model="device.open_duration"
                @input="validateNumberRange" />
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="add-device-button mt-3 pb-6">
      <vs-button @click="addDevice" class="unimacs_button">{{ buttonText }} Extension Device
      </vs-button>
    </div>
  </div>

</template>

<script>
import vSelect from "vue-select";
import { ValidateIPaddress } from "@/functions/IP_validator.js";
export default {
  props: {
    propsData: {
      type: Object,
    },
    expansion_boards: {
      type: Object,
    },
    resetTree: {
      type: Function
    }
  },
  computed: {
    active_device() {
      return this.$store.state.accessPoint.active_device;
    },
    acu_models() {
      return this.$store.state.accessPoint.acu_models;
    },
    edit_data() {
      return this.$store.state.accessPoint.edit_acu_data;
    },
    new_ext_device() {
      return this.$store.state.accessPoint.edit_acu_data.new_ext_device;
    },
    acuModel() {
      return this.$store.state.accessPoint.edit_acu_data.model;
    },
    isFloor() {
      let model = this.acuModel;
      let elevator_mode =
        this.$store.state.accessPoint.edit_acu_data.elevator_mode;

      if ((model == "Icon" || model == "Icon-PRO") && elevator_mode) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    propsData: {
      handler(newVal, oldVal) {
        if (newVal.data) {
          this.propsData.board = newVal.data.info.ext_board;
          let selectedItemType = {}
          for (let elem in this.expansion_boards) {
            if (this.expansion_boards[elem][newVal.data.info.ext_board]) {
              selectedItemType = this.expansion_boards[elem][newVal.data.info.ext_board]
            }
          }
          this.selectedItem = selectedItemType;
          this.isREX = newVal.data.info.ext_board == "REX-16";

          const device = {
            ...newVal.data.info,
            osdp_key_update_date: `${this.$moment(newVal.data.info.osdp_key_update_date).format("YYYY-MM-DD HH:mm")}`,
            relay_mode: newVal.data.info.relay_mode,
            condition: newVal.data.info.condition,
          }
          this.createDefaultValue(device)
        } else {
          this.selectedItem = this.expansion_boards[newVal.defaultName][newVal.name];

          if (!this.selectedItem) {
            for (let elem in this.expansion_boards) {
              if (this.expansion_boards[elem][newVal.board]) {
                this.selectedItem = this.expansion_boards[elem][newVal.board]
              }
            }
          }

          this.isREX = newVal.board == "REX-16";
        }
        this.device.device_model = this.propsData.board;
      },
      deep: true,
      immediate: true
    },
    active_device(device) {
      this.disableIfFloor(this.isFloor);

      let active_dev;
      if (this.active_device.includes("ext_")) {
        active_dev = +this.active_device.split("_", 2)[1];
      }
      let ext_device;
      if (Number.isInteger(+active_dev)) {
        this.buttonText = "Update ";
        ext_device = this.edit_data.ext_devices.find(
          (a) => a.id == +active_dev
        );
        this.device = JSON.parse(JSON.stringify(ext_device));

      } else {
        this.buttonText = "Add ";
        if (
          this.new_ext_device &&
          this.new_ext_device[device] &&
          !this.new_ext_device[device].deleted
        ) {
          this.device = JSON.parse(JSON.stringify(this.new_ext_device[device]));
        } else if (this.new_ext_device[device].deleted) {
          ext_device = this.edit_data.ext_devices.find(
            (a) => a.save_id == device
          );
          this.device = JSON.parse(JSON.stringify(ext_device));
          this.buttonText = "Update ";
        }
      }
    },
    device: {
      handler: function (data, oldVal) {
        this.$store.commit("accessPoint/SET_DEVICE_INFO", data);
      },
      deep: true,
    },
  },
  data() {
    return {
      isREX: false,
      OSDP_types: [
        {
          id: 'OSDP_V1',
          label: "OSDP v.1",
        },
        {
          id: 'OSDP_V2',
          label: "OSDP v.2",
        }
      ],
      condition_list: [
        {
          id: 0,
          label: "NC",
        },
        {
          id: 1,
          label: "NO",
        },
      ],
      relayModeList: [
        {
          id: 0,
          label: "Trigger",
        },
        {
          id: 1,
          label: "Impulse",
        },
      ],
      buttonText: null,
      device: {
        osdp_key_update_date: null,
        relay_mode: 0,
        condition: 0,
        protocol: "OSDP_V1",
        name: null,
        description: null,
        device_model: null,
        address: null,
        boud_rate: null,
        board: null,
        protocol: null,
        interface: null,
        baud_rate: null,
      },
      deviceModels: [
        {
          id: "1",
          label: "AIR-R"
        },
        {
          id: "2",
          label: "ICONex"
        },
        {
          id: "3",
          label: "IB-16"
        },
        {
          id: "4",
          label: "RB-16"
        },
      ],
      protocoles: [
        {
          id: "OSDPe",
          label: "OSDPe",
        },
        {
          id: "OSDP",
          label: "OSDP",
        },
        {
          id: "Default",
          label: "Default",
        },
      ],
      interfaces: [
        {
          id: 0,
          label: "RS485",
        },
        {
          id: 1,
          label: "Ethernet",
        },
      ],
      selectedItem: null
    };
  },
  methods: {

    createDefaultValue(data) {
      this.device = data
      return
    },

    updateRelayMode(key = "updateRelayMode") {
      this.device[key] = !this.device[key]
    },
    validationTextLength(event, key) {
      this.device[key] = event.slice(0, 25);
    },

    validateOSDPKeyPassword(event) {
      let value = event;
      value = value.replace(/[^a-zA-Z0-9]/g, '');

      if (value.length > 255) {
        value = value.substring(0, 255);
      }

      this.device.osdp_key = value;
    },

    impulseDurationValidation(input) {
      const regex = /^([0-2](\.\d?)?)?$/; // Adjusted regex for "0." case
      if (regex.test(input)) {
        this.device.impulse_time = input;
        return
      }
      this.device.impulse_time = "2";
      return
    },

    validateNumberRange(value) {
      if (value === "0") {
        this.device.open_duration = 1;
        return
      }
      const number = Number(value);
      const result = value === "" || (!isNaN(number) && number >= 0 && number <= 60);
      if (result) {
        this.device.open_duration = value;
      } else {
        this.device.open_duration = value > 60 ? 60 : 0
      }
    },

    validateInput(event) {
      let value = event;

      if (value === "e" || value === "E") {
        value = "0";
      }
      value = value.replace(/[^0-9]/g, '');

      if (value !== "0") {
        value = value.replace(/^0+/, '');
      }

      if (value === '') {
        this.device.address = '';
      } else {
        let num = parseInt(value, 10);

        if (isNaN(num)) {
          this.device.address = '';
        } else if (num > this.selectedItem.max_address) {
          this.device.address = `${this.selectedItem.max_address}`;
        } else {
          this.device.address = num.toString();
        }
      }
    },
    setKeyHandler() {
    },
    addDevice() {
      const acu_id = this.$store.state.accessPoint.edit_acu_data.id;

      let active_dev;

      if (this.active_device.includes("ext_")) {
        active_dev = +this.active_device.split("_", 2)[1];
      }

      if (Number.isInteger(+active_dev)) {
        this.$store
          .dispatch("accessPoint/updateDevices", this.device)
          .then((res) => {
            if (res.data.message) {
              this.$vs.notify({
                time: 7000,
                color: "success",
                title: res.data.message,
              });
            } else {
              let ext_device;

              ext_device = this.edit_data.ext_devices.find(
                (a) => a.id == +res.data.id
              );

              this.device = { ...ext_device };

              this.$vs.notify({
                time: 7000,
                color: "success",
                title: "Extention device updated",
              });
            }
            this.$vs.loading.close();
            this.resetTree();
          });
      } else {
        const obj = {
          name: this.device.name,
          acu: acu_id,
          description: this.device.description,
          device_model: this.propsData.board,
          secure_mode: this.device.secure_mode,
          osdp_key: this.device.osdp_key,
          address: +this.device.address,
          protocol: this.device.protocol,
          ext_board: this.propsData.board,
        };

        if (this.device.condition) {
          obj.condition = this.device.condition
          obj.resource_apply = this.device.resource_apply;
        } else {
          obj.impulse_time = +this.device.impulse_time;
          obj.open_duration = +this.device.open_duration;
          obj.relay_mode = this.device.relay_mode;
          obj.resource_apply = this.device.resource_apply;
        }

        if (
          this.new_ext_device[this.active_device] &&
          !this.new_ext_device[this.active_device].deleted
        ) {
          this.$store.dispatch("accessPoint/addDevices", obj).then((res) => {
            this.buttonText = "Update ";

            this.$vs.notify({
              time: 7000,
              color: "success",
              title: "Extention device created",
            });
            let ext_device;

            ext_device = this.edit_data.ext_devices.find(
              (a) => a.id == +res.data.id
            );
            this.device = { ...ext_device };

            this.$parent.changeExtName(obj);
            this.$vs.loading.close();
            this.resetTree();
          });
        } else if (
          this.new_ext_device[this.active_device] &&
          this.new_ext_device[this.active_device].deleted
        ) {
          obj.id = this.device.id;
          this.$store.dispatch("accessPoint/updateDevices", obj).then((res) => {
            this.$vs.notify({
              time: 7000,
              color: "success",
              title: "Extention device updated",
            });
            let ext_device;
            ext_device = this.edit_data.ext_devices.find(
              (a) => a.id == +obj.id
            );

            this.device = { ...ext_device };

            this.$vs.loading.close();
            this.resetTree();
          });
        }
      }

    },

    disableIfFloor(floor) {
      let findInterface = this.interfaces.find((i) => i.id === 1);
      if (floor) {
        findInterface.disabled = true;
      } else {
        findInterface.disabled = false;
      }
    },

  },
  mounted() {
    let active_dev;

    if (this.active_device.includes("ext_")) {
      active_dev = +this.active_device.split("_", 2)[1];
    }

    let ext_device;

    let addr = [];



    if (Number.isInteger(+active_dev)) {
      this.buttonText = "Update ";
      ext_device = this.edit_data.ext_devices.find((a) => a.id == +active_dev);
      this.device = JSON.parse(JSON.stringify(ext_device));
    } else {
      this.device = JSON.parse(
        JSON.stringify(this.edit_data.new_ext_device[this.active_device])
      );
      this.device.device_model = this.propsData.board;
    }
    if(this.propsData.board === 'GENERIC'){
      this.device.protocol = 'OSDP_V1'
    }
    // let active_dev;

    // if (this.active_device.includes("ext_")) {
    //   active_dev = +this.active_device.split("_", 2)[1];
    // }
    // if (!Number.isInteger(+active_dev)) {

    // }
  },
  created() {
    this.disableIfFloor(this.isFloor);
    let active_dev;

    if (this.active_device.includes("ext_")) {
      active_dev = +this.active_device.split("_", 2)[1];
    }

    let ext_device;

    let addr = [];


    if (Number.isInteger(+active_dev)) {
      this.buttonText = "Update ";
      ext_device = this.edit_data.ext_devices.find((a) => a.id == +active_dev);
      this.device = JSON.parse(JSON.stringify(ext_device));
    } else {
      this.buttonText = "Add ";
      if (
        this.edit_data.new_ext_device &&
        this.edit_data.new_ext_device[this.active_device] &&
        !this.edit_data.new_ext_device[this.active_device].deleted
      ) {
        this.device = this.edit_data.new_ext_device[this.active_device] ? JSON.parse(
          JSON.stringify(this.edit_data.new_ext_device[this.active_device])) : this.edit_data.new_ext_device[this.active_device]

      } else if (this.edit_data.new_ext_device[this.active_device].deleted) {
        ext_device = this.edit_data.ext_devices.find(
          (a) => a.ext_board == this.active_device
        );

        this.device = ext_device ? JSON.parse(JSON.stringify(ext_device)) : ext_device;
      }

    }
    this.$validator.extend("validateIP", {
      getMessage: (field) => field + " not valid",
      validate: (value) => {
        return ValidateIPaddress(value);
      },
    });
  },
  components: {
    vSelect,
  },
};
</script>

<style scoped lang="scss">
.extension-device-input {
  // background: #E60 !important;

  .vs-con-input {
    padding-top: 15px;
    background: #E60 !important;
    height: 40px;
  }
}

.add-device-button {
  display: flex;
  justify-content: flex-end;
}

.secure-container {
  .title {
    margin-top: 0 !important;
  }
}

.reader-item-device-info {
  display: flex;

  .flex-item.info.secure-connection {
    min-height: 105px;
  }

  .flex-item.title {
    margin-top: 12px;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
  }

  .flex-item.info {
    margin-top: 2px;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 400;
    background: #10163a;
    padding: 6px 12px;
    border-radius: 6px;
    min-height: 155px;

    div {
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-size: 14px;
      font-weight: 500;
    }
  }
}

.set-key {
  height: 33px;
  padding: 4px !important;
  background-color: #3e7ea2 !important;
}

.flex-item {
  display: flex;
  width: 100%;
}

.reader-item-settings {
  .label {
    border-bottom: 2px solid #10163a;
    width: 100%;
    font-weight: 500;
  }

  .check-box-item {
    font-size: 12px;
  }
}

.ext_device_block {
  position: absolute;
  bottom: 10px;
  right: 15px;
}
</style>
